import { NgModule, SkipSelf, Optional, Injector } from '@angular/core';
import { FooterComponent } from './components/footer/footer.component';
import { HeaderComponent } from './components/header/header.component';
import { HomeComponent } from './components/home/home.component';
import { createTranslateLoader, SharedModule } from '../shared/shared.module';
import { BrowserModule } from '@angular/platform-browser';
import { AppComponent } from './components/app/app.component';
import { API_CONFIG } from '@ff/api';
import { environment } from '../../../environments/environment';
import { RouterModule } from '@angular/router';
import { routes } from './core.routes';
import { ATInternetModule } from '@ff/at-internet';
import { UserModule } from '@ff/user';
import { AuthModule } from '@ff/auth';
import { AuthModule as AppAuthModule } from '../auth/auth.module';
import { UserModule as AppUserModule } from '../user/user.module';
import { AUTH_CONFIG } from '@ff/auth';
import { USER_CONFIG } from '@ff/user';
import { OAUTH2_CONFIG } from '@ff/oauth2';
import { NgSelectModule } from '@ng-select/ng-select';
import { HttpClient, HTTP_INTERCEPTORS } from '@angular/common/http';
import { LangChangeEvent, TranslateLoader, TranslateModule, TranslateService } from '@ngx-translate/core';
import { NavigationComponent } from './navigation/navigation.component';
import { MatChipsModule } from '@angular/material/chips';
import { DateAdapter, MatNativeDateModule, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatRadioModule } from '@angular/material/radio';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatStepperModule } from '@angular/material/stepper';
import { MatTabsModule } from '@angular/material/tabs';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS, MomentDateAdapter } from '@angular/material-moment-adapter';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { UserResolver } from './resolvers/user.resolver';
import { registerLocaleData } from '@angular/common';
import  localeFr  from '@angular/common/locales/fr';
import { ServiceLocator } from '../_services/_locator.service';
import { TokenExpireInterceptor } from '../_interceptors/token-expire.interceptor';

registerLocaleData(localeFr);

@NgModule({
    declarations: [
        AppComponent,
        HeaderComponent,
        FooterComponent,
        HomeComponent,
        NavigationComponent,
    ],
    providers: [
        UserResolver,
        { provide: HTTP_INTERCEPTORS, useClass: TokenExpireInterceptor, multi: true },
        {
            provide: AUTH_CONFIG,
            useValue: {
                host: environment.api.host
            }
        },
        {
            provide: API_CONFIG,
            useValue: {
                host: environment.api.host
            }
        },
        {
            provide: USER_CONFIG,
            useValue: {
                host: environment.api.host
            }
        },
        {
            provide: OAUTH2_CONFIG,
            useValue: {
                host: environment.api.host,
                endpoints: {
                    bearer: '/oauth2/token',
                    providers: '/oauth2/providers'
                }
            }
        },

    ],
    imports: [

        // FF packages
        UserModule,
        AuthModule,
        ATInternetModule,
        // Angular Packages

        RouterModule.forRoot(routes,
            { enableTracing: false } // <-- activation des logs !),
        ),
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: (createTranslateLoader),
                deps: [HttpClient],
            }
        }),

        // App packages

        SharedModule,
        AppAuthModule,
        AppUserModule,
        NgSelectModule,
        // Angular
        BrowserModule,
        BrowserAnimationsModule,
        MatTabsModule,
        MatStepperModule,
        MatAutocompleteModule,
        MatRadioModule,
        MatExpansionModule,
        MatDatepickerModule,
        MatNativeDateModule,
        MatChipsModule,
        ReactiveFormsModule,
        FormsModule,
    ],
    exports: [
        RouterModule,
    ],
    bootstrap: [
        AppComponent
    ],

})
export class CoreModule {

    public constructor(
        @Optional() @SkipSelf() parent: CoreModule,
        private adapter: DateAdapter<Date>,
        private translate: TranslateService,
        private injector: Injector
    ) {
        if (parent) {
            throw new Error('CoreModule should not be exported then imported by another module!');
        }
        this.translate.onLangChange
        .subscribe(({ lang }: LangChangeEvent) => {
            this.adapter.setLocale(lang);
        });
        this.translate.addLangs(['fr','en']);
        ServiceLocator.injector = injector;
    }

}
